import { fetchItemLicenses } from './searchPage'
import { fetchSimilarItems } from './fetchSimilarItems'

export const closeModal = () => {
  return {
    type: 'closeModal'
  }
}

export const openModal = data => {
  return {
    type: 'openModal',
    payload: data
  }
}

export const showModalMessage = data => {
  return {
    type: 'showModalMessage',
    payload: data
  }
}

export const dismissModalMessage = () => {
  return {
    type: 'dismissModalMessage'
  }
}

export const toggleOffCanvas = direction => {
  return {
    type: 'toggleOffCanvas',
    payload: direction
  }
}

export const initToggledPanels = () => {
  return {
    type: 'initToggledPanels'
  }
}

export const togglePanel = ({ panelId, currentlyExpanded }) => {
  return {
    type: 'togglePanel',
    payload: { panelId, currentlyExpanded }
  }
}

export const togglePanelOptions = panelId => {
  return {
    type: 'togglePanelOptions',
    payload: panelId
  }
}

export const toggleSidebar = () => {
  return {
    type: 'toggleSidebar'
  }
}

export const selectItem = item => {
  return (dispatch, getState) => {
    dispatch(fetchItemLicenses(item.id))
    dispatch(fetchSimilarItems(item.id))
    return dispatch(selectItemAction(item))
  }
}

export const selectItemAction = item => {
  return { type: 'selectItem', payload: item }
}

export const setOffsetTop = offsetTop => {
  return {
    type: 'offsetTop',
    payload: { offsetTop }
  }
}
